import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { compose } from 'recompose'
import { updateTenantApplication } from 'api'
import {
  withJsonApiProps,
  withLayout,
  useStepFormSubmit,
  useOrderedSteps,
  goToNextStep,
} from 'utils'
import { ApplicationLayout } from 'components'
import { CustomDisclaimerForm } from 'forms'
import { STEP } from 'config'

const propTypes = {
  disclaimerText: PropTypes.string,
  customDisclaimerAcknowledged: PropTypes.string,
}
const defaultProps = {}

function CustomDisclaimer({ disclaimerText, customDisclaimerAcknowledged }) {
  const { handleSubmitUpdate } = useStepFormSubmit({
    updateRequest: updateTenantApplication,
  })
  const [steps] = useOrderedSteps()

  return (
    <>
      <Helmet>
        <title>Disclaimer</title>
      </Helmet>
      <div className="page-header">
        <h1>Disclaimer</h1>
        <p>Please review the following disclaimer and check the box below to acknowledge.</p>
      </div>
      <CustomDisclaimerForm
        disclaimerText={disclaimerText}
        initialValues={{
          tenantApplication: {
            customDisclaimerAcknowledged: customDisclaimerAcknowledged || '',
          },
        }}
        onSubmit={async () => {
          const isSubmitSuccess = await handleSubmitUpdate({
            tenantApplication: {
              customDisclaimerAcknowledged: new Date().toISOString(),
              currentStep: STEP.CUSTOM_DISCLAIMER.name,
            },
          })
          if (isSubmitSuccess) {
            const disclaimerIndex = steps.findIndex(
              (s) => s?.name === STEP.CUSTOM_DISCLAIMER.name
            )
            const nextStep = steps[disclaimerIndex + 1]
            if (nextStep) goToNextStep(nextStep)
          }
        }}
      />
    </>
  )
}

CustomDisclaimer.propTypes = propTypes
CustomDisclaimer.defaultProps = defaultProps

export default compose(
  withJsonApiProps(),
  withLayout(ApplicationLayout)
)(CustomDisclaimer)
